$(function() {
	
    $.urlParam = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)')
                      .exec(window.location.search);

    return (results !== null) ? results[1] || 0 : false;
  }

    if($.urlParam('aid') != false){
      	$('#ambassador_id').val($.urlParam('aid'));
      	$('#ambassador_id').attr('readonly','true').css('background-color','#d6d6d6');
      	console.log($.urlParam('aid')); //edit
    }
	
  $("#first_name").on("focusout", function() {
    if($(this).val() == ''){
    	$(this).css('border','1px solid red');
    }else{
    	$(this).css('border','1px solid #0f710d');      
    }    
  });
	
  $("#last_name").on("focusout", function() {
    if($(this).val() == ''){
    	$(this).css('border','1px solid red');
    }else{
    	$(this).css('border','1px solid #0f710d');      
    }    
  });
	
  $("#cell_phone").on("focusout", function() {
    if($(this).val() == ''){
    	$(this).css('border','1px solid red');
    }else{
    	$(this).css('border','1px solid #0f710d');      
    }    
  });
	
  $("#email_address").on("focusout", function() {
    if($(this).val() == ''){
    	$(this).css('border','1px solid red');
    }else{
    	$(this).css('border','1px solid #0f710d');      
    }    
  });

    
  $('#signup-now').on('click', function(){
   
    

     $('#validate-error-first_name').css('display','none');
     $('#validate-error-last_name').css('display','none');
     $('#validate-error-cell_phone').css('display','none');
     $('#validate-error-email_address').css('display','none');
    
     $('#first_name').css('border','1px solid #0f710d');
     $('#last_name').css('border','1px solid #0f710d');
     $('#cell_phone').css('border','1px solid #0f710d');
     $('#email_address').css('border','1px solid #0f710d');
    
      var validateStatus = true;

      //console.log(cartData);
      //console.log('First Name: ' + $('#first_name').val());   

      //alert('hi!');
      var public_token = '4NxhvvJ7up6WTMtX7ZcBss4dAkbNbKefQVXtsXvr';  

      var cell_phone = $('#cell_phone').val();
      if(cell_phone == ''){
        validateStatus = false;
        $('#validate-error-cell_phone').css('display','block');
        $('#validate-error-message-cell_phone').text('Cell Phone is a required field. Please be sure to fill it out.');
        $('#cell_phone').css('border','1px solid red');
      }

      var email_address = $('#email_address').val();    
      if(email_address == ''){
        validateStatus = false;
        $('#validate-error-email_address').css('display','block');
        $('#validate-error-message-email_address').text('Email address is a required field. Please be sure to fill it out.');
        $('#email_address').css('border','1px solid red');
      }    

      var last_name = $('#last_name').val();
      if(last_name == ''){
        validateStatus = false;
        $('#validate-error-last_name').css('display','block');
        $('#validate-error-message-last_name').text('Last Name is a required field. Please be sure to fill it out.');
        $('#last_name').css('border','1px solid red');
      }

      var first_name = $('#first_name').val();
      if(first_name == ''){
        validateStatus = false;
        $('#validate-error-first_name').css('display','block');
        $('#validate-error-message-first_name').text('First Name is a required field. Please be sure to fill it out.');
        $('#first_name').css('border','1px solid red');
      }

      var notes = $('#notes').val();

      if(validateStatus == true){



        $('#signup-now').text('Processing...');

        $.post( "https://jewelety.com/api/v2/ambassador-signup", { public_token:public_token,first_name: first_name, last_name: last_name, email_address: email_address, cell_phone: cell_phone, notes:notes})
        .done(function( data ) {

          $('#signup-form').css('display','none');
          $('#signup-success').css('display','block');

        }); 						
          
                   



      };
            
            
        
    });

      
  

  
});